import { useTheme, useMediaQuery } from '@mui/material';
import DashboardContribuenteDesktop from './DashboardContribuenteDesktop';
import DashboardContribuenteMobile from './DashboardContribuenteMobile';

export default function DashboardContribuentePage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <DashboardContribuenteMobile />
    : <DashboardContribuenteDesktop />;
}